module.exports = __webpack_public_path__ + "media/images/countrysquared/si-597763e672293db896346836b3da2666.svg";